const MARK = "chatisafe-native";

/** True inside the Expo WebView. The WebView's user agent is not reliable, so the app also sets a flag. */
export function isNativeAppClient() {
  if (typeof navigator !== "undefined" && navigator.userAgent.includes("ChatiSafeMobile")) return true;
  try {
    if (localStorage.getItem(MARK) === "1") return true;
  } catch {
    /* ignore */
  }
  if (typeof document !== "undefined" && document.cookie.includes("chatisafe_app=1")) return true;
  if (typeof location !== "undefined" && new URLSearchParams(location.search).get("csapp") === "1") return true;
  if (typeof document !== "undefined" && document.documentElement.classList.contains(MARK)) return true;
  return false;
}

/** Logout in the app goes to the login screen. The marketing homepage stays out of the app. */
export function nativeLogout() {
  if (!isNativeAppClient()) return false;
  window.location.assign("/login?csapp=1");
  return true;
}
